import { createElement as y } from "react";
import '../../../styles/DCarouselHelpers.css';const w = "_dCarousel_pk9n9_1", _ = "_dCarouselContainer_pk9n9_19", k = "_dCarouselContainerOverflowHidden_pk9n9_23", O = "_dCarouselCard_pk9n9_27", $ = {
  dCarousel: w,
  dCarouselContainer: _,
  dCarouselContainerOverflowHidden: k,
  dCarouselCard: O
}, J = (s, a, t, n) => {
  let r = [], o = 0, f = [], u = [], e = 0, c = a.length, i = 0, L = {}, m = {};
  if (!s)
    return r = a.map((l, C) => {
      const p = Number(l.props.customSpan) || 1, d = p > t ? t : p;
      for (let h = 0; h < d; h++)
        L[C] = i, o++, m[C] ? m[C].push(o) : m[C] = [o];
      return o >= t && a[C + 1] && (i += 1), y(
        "div",
        {
          key: `d-carousel-card-${C}`,
          className: $.dCarouselCard,
          "data-custom-span": d || 1,
          ref: (h) => n.current[C] = h
        },
        l
      );
    }), {
      beginningIndex: e,
      sections: r,
      endingIndex: c,
      sectionIndexes: JSON.stringify(L),
      totalSections: i,
      cellIndexes: JSON.stringify(m),
      totalCells: o
    };
  for (let l = a.length - 1; l >= 0; l--) {
    const C = a[l];
    if (o += Number(C.props.customSpan) || 1, f.push(C), o >= t) {
      f = f.reverse(), e = f.length;
      break;
    }
  }
  o = 0;
  for (let l = 0; l < a.length; l++) {
    const C = a[l], p = Number(C.props.customSpan) || 1;
    for (let d = 0; d < p; d++)
      L[l] = i, o++, m[l] ? m[l].push(o) : m[l] = [o];
    o >= t && a[l + 1] && (i += 1);
  }
  o = 0;
  for (let l = 0; l < a.length; l++) {
    const C = a[l];
    if (o += Number(C.props.customSpan) || 1, u.push(C), o >= t)
      break;
  }
  return r = [...f, ...a, ...u], c = e + a.length, r = r.map((l, C) => {
    const p = C < e || C > c - 1, d = Number(l.props.customSpan) || 1, h = d > t ? t : d;
    return y(
      "div",
      {
        className: p ? $.dCarouselCardClone : $.dCarouselCard,
        key: `d-carousel-card-${C}`,
        "data-custom-span": h || 1,
        "aria-hidden": p,
        "aria-roledescription": p ? "Carousel slide clone" : "Carousel slide",
        ref: (N) => n.current[C] = N
      },
      l
    );
  }), {
    beginningIndex: e,
    sections: r,
    endingIndex: c,
    sectionIndexes: JSON.stringify(L),
    totalSections: i,
    cellIndexes: JSON.stringify(m),
    totalCells: o
  };
}, B = (s, a, t, n, r, o, f) => {
  const u = o ? f ? t - s < r ? t === r ? n - a : r : t === n - a ? t - ((n - r) % s || s) : t - s : t - s < r ? n + (t - r) - s : t - s : t - s <= 0 ? 0 : t - s;
  return u >= 0 ? u : t;
}, v = (s, a, t, n) => {
  const r = JSON.parse(a), o = Object.values(r);
  let f = t;
  if (s) {
    let u = 0;
    for (let e = o.length - 1; e >= 0; e--) {
      if (u += o[e].length, u > n) {
        f = e + 1;
        break;
      }
      e === 0 && (f = 0);
    }
  }
  return f;
}, E = (s, a, t, n, r, o, f, u) => {
  const e = v(f, u, n, a) + (o && f ? r : 0), c = o ? f ? t + s >= e ? t === e ? r : e : t + s : t + s >= e ? r - (e - t) + s : t + s : f ? t + s >= e ? e : t + s : t + s >= e ? t : t + s;
  return c >= 0 ? c : t;
}, j = (s, a, t, n, r) => {
  if (s)
    for (let o = 0; o < s.length; o++) {
      const f = s[o];
      if (a < f.breakpoint) {
        n((u) => {
          const e = Object.assign({}, t, f.settings), c = JSON.stringify(u), i = JSON.stringify(e);
          return r(c !== i), e;
        });
        return;
      }
    }
  n((o) => {
    const f = { ...t };
    return r(o.cardsPerSection !== f.cardsPerSection), f;
  });
}, F = (s) => {
  s((a) => {
    for (let t = a.length - 1; t >= 0; t--) {
      const n = a[t];
      clearTimeout(n), a.pop();
    }
    return a;
  });
}, M = (s, a, t, n, r, o, f, u, e) => {
  const c = a.current, i = t.current, L = n.current, m = c[r];
  if (L && i && c.length > 0) {
    const l = i.getBoundingClientRect().left - L.getBoundingClientRect().left - i.offsetLeft;
    if (i.getAnimations().forEach((p) => p.cancel()), (s === "next" ? Math.abs(l) < m.offsetLeft : m.offsetLeft < Math.abs(l)) || !o)
      i.animate(
        [
          { transform: `translate3d(${l}px, 0, 0)` },
          { transform: `translate3d(${-(m.offsetLeft - 1)}px, 0, 0)` }
        ],
        f
      );
    else if (s === "next") {
      const p = c[u - 1].offsetLeft - Math.abs(l), d = m.offsetLeft - c[e - 1].offsetLeft, h = p + d, N = p / h;
      i.animate(
        {
          transform: [
            `translate3d(${l}px, 0, 0)`,
            `translate3d(${-c[u - 1].offsetLeft}px, 0, 0)`,
            `translate3d(${-c[e - 1].offsetLeft}px, 0, 0)`,
            `translate3d(${-(m.offsetLeft - 1)}px, 0, 0)`
          ],
          offset: [0, N, N, 1]
        },
        f
      );
    } else {
      const p = Math.abs(l) - c[e - 1].offsetLeft, d = c[u].offsetLeft - m.offsetLeft, h = p + d, N = p / h;
      i.animate(
        {
          transform: [
            `translate3d(${l}px, 0, 0)`,
            `translate3d(${-c[e - 1].offsetLeft}px, 0, 0)`,
            `translate3d(${-c[u - 1].offsetLeft}px, 0, 0)`,
            `translate3d(${-(m.offsetLeft - 1)}px, 0, 0)`
          ],
          offset: [0, N, N, 1]
        },
        f
      );
    }
  }
}, A = (s, a, t, n, r, o, f, u) => {
  let e = 0;
  return !s || a ? (n + t < o ? e = u[n - r] : e = f, n < r + t && (e = 1), n === r && (e = 0)) : e = u[n - r], e;
}, g = (s, a, t, n, r, o, f, u) => {
  if (s) {
    if (s === "backwards") {
      const e = a[t].offsetLeft + n;
      r.animate(
        {
          transform: `translate3d(${-(a[o].offsetLeft - e)}px, 0, 0)`
        },
        { fill: "forwards", duration: 0 }
      );
    } else if (s === "forwards") {
      const e = a[o].offsetLeft + n;
      r.animate(
        {
          transform: `translate3d(${-(a[t].offsetLeft - e)}px, 0, 0)`
        },
        { fill: "forwards", duration: 0 }
      );
    }
  } else
    r.animate(
      { transform: `translate3d(${n - (f - u)}px, 0, 0)` },
      { fill: "forwards", duration: 0 }
    );
}, H = (s, a, t, n, r) => {
  const o = s.current, f = a.current;
  f && o && (o.style.setProperty("--d-carousel-cards-per-sections", String(t)), n && f.style.setProperty("--d-carousel-gap", n), t && f.style.setProperty("--d-carousel-cards-per-section", String(t)), r && f.querySelectorAll("[data-custom-span]").forEach((e) => {
    const c = e.getAttribute("data-custom-span");
    c && (e.style.gridColumn = `span ${c}`);
  }));
};
export {
  M as animateCarousel,
  F as clearCurrentTimeout,
  J as createCardSections,
  g as dragMoveCarousel,
  A as findCurrentSection,
  v as findFinalCard,
  E as findNextCard,
  B as findPrevCard,
  H as initCardWidths,
  $ as s,
  j as updateResponsiveSettings
};
//# sourceMappingURL=DCarouselHelpers.js.map
